var map = {
	"./APA7-Advertisement.js": 26887,
	"./APA7-AncientClassicWork.js": 88985,
	"./APA7-Anthology.js": 81499,
	"./APA7-Apparatus.js": 14507,
	"./APA7-Artwork.js": 47110,
	"./APA7-BillsResolutions.js": 54301,
	"./APA7-Blog.js": 80960,
	"./APA7-Book.js": 46425,
	"./APA7-Brochures.js": 20375,
	"./APA7-ChartsMaps.js": 43446,
	"./APA7-ConferenceMaterials.js": 71898,
	"./APA7-Constitutions.js": 52278,
	"./APA7-Datasets.js": 90793,
	"./APA7-Dissertations.js": 7602,
	"./APA7-Engine.js": 78166,
	"./APA7-ExecutiveOrders.js": 36389,
	"./APA7-Films.js": 80549,
	"./APA7-Grants.js": 64991,
	"./APA7-GrayLiterature.js": 57968,
	"./APA7-InformalWorks.js": 19900,
	"./APA7-Interview.js": 38529,
	"./APA7-Journal.js": 52093,
	"./APA7-Lectures.js": 93207,
	"./APA7-Magazine.js": 70494,
	"./APA7-Manuscript.js": 29344,
	"./APA7-Music.js": 7969,
	"./APA7-Newspaper.js": 15501,
	"./APA7-OnlineComment.js": 48106,
	"./APA7-Patent.js": 66002,
	"./APA7-PersonalCommunication.js": 66646,
	"./APA7-PodcastsRadio.js": 68158,
	"./APA7-PressRelease.js": 78520,
	"./APA7-ReferenceWorks.js": 66149,
	"./APA7-Regulations.js": 2371,
	"./APA7-ReligiousWork.js": 39540,
	"./APA7-Reviews.js": 64607,
	"./APA7-Shared.js": 85981,
	"./APA7-SocialMedia.js": 41711,
	"./APA7-Software.js": 7253,
	"./APA7-SpecialRules.js": 11014,
	"./APA7-Speech.js": 2334,
	"./APA7-Statutes.js": 7811,
	"./APA7-Television.js": 17452,
	"./APA7-Testimonies.js": 57744,
	"./APA7-TestsScales.js": 14188,
	"./APA7-Treaties.js": 89183,
	"./APA7-USFederalCourtCases.js": 48663,
	"./APA7-USStateCourtCases.js": 5423,
	"./APA7-Videos.js": 92212,
	"./APA7-Webpage.js": 70183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58500;